<script>
  import { activitiesStore } from "@stores/activitiesStores.js";
  import Button from "lib/components/buttonIconOnly.svelte";
  import AssistantChevrons from "lib/components/assistant/assistantChevrons.svelte";
  import Toggle from "lib/components/Toggle.svelte";
  import { Modal, TextInput, SkeletonText } from "carbon-components-svelte";
  import ButtonColorSelector from "./ButtonColorSelector.svelte";

  export let activities = [];
  export let analysisid;
  export let activitiesToShow = [];

  const { saveActivity } = activitiesStore;
  const itemsPerPage = 7;

  let editActivityName = "";
  let editActivityColor = "#93EDA3";
  let editActivityId = "";
  let loading = false;
  let searchTerm = "";
  let showall = false;
  let filteredData = [];
  let currentPage = 1;
  let paginatedData = [];
  let modalOpen = false;
  let listOfColors = [
    { name: "green", value: "#93EDA3" },
    { name: "red", value: "#F86353" },
    { name: "yellow", value: "#FBF26C" },
    { name: "blue", value: "#99C1F2" },
  ];
  let activitiesList = activities;

  $: ({ allActivities } = $activitiesStore);

  $: activities = activities.map((activity) => {
    const updatedActivity = allActivities.find(
      (a) => a.id === activity.activityid
    );
    return updatedActivity ? { ...activity, ...updatedActivity } : activity;
  });

  $: if (activities) search(searchTerm, showall);

  $: search(searchTerm, showall);

  $: {
    if (allActivities) {
      search(searchTerm, showall);
      updatePagination();
    }
  }

  $: setActivitiesList(activities, activitiesToShow);

  function setActivitiesList(activities, activitiesToShow) {
    activitiesList = [];
    activities.forEach((activity) => {
      if (activitiesToShow.find((node) => node.id === activity.activity_name)) {
        activitiesList.push(activity);
      }
    });
    search(searchTerm, showall);
  }

  function search(searchTerm, showall) {
    const filterFrom = showall ? activities : activitiesList;
    filteredData = filterFrom.filter((item) => {
      return item.activity_name.toLowerCase().includes(searchTerm.toLowerCase());
    });
    currentPage = 1;
    updatePagination();
  }

  function updatePagination() {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    paginatedData = filteredData.slice(startIndex, endIndex);
  }

  function goToPage(pageNumber) {
    if (pageNumber < 1) {
      currentPage = 1;
    } else if (pageNumber > Math.ceil(filteredData.length / itemsPerPage)) {
      currentPage = Math.ceil(filteredData.length / itemsPerPage);
    } else {
      currentPage = pageNumber;
    }
    updatePagination();
  }

  function handleInput(event) {
    searchTerm = event.target.value;
  }

  function setColor(color) {
    editActivityColor = color;
  }

  function handleFocus() {
    if (modalOpen) {
      const inputElement = document.getElementById(
        `text-input-${editActivityName}`
      );
      if (inputElement) {
        inputElement.focus();
      }
    }
  }
</script>

<div class="addToActivityWrapper">
  <div class="top_bar">
    <div
      class="search_wrapper"
      class:disabled={!paginatedData || paginatedData.length === 0}
    >
      <div class="search">
        <div class="searchicon">
          <svg
            height="100%"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.1466 24L14.8751 14.4151C14.077 15.0963 13.1462 15.6125 12.0828 15.9637C11.0193 16.3149 9.96862 16.4906 8.9306 16.4906C6.45541 16.4906 4.36059 15.6939 2.64614 14.1005C0.931688 12.5071 0.0744629 10.5574 0.0744629 8.25144C0.0744629 5.94545 0.928225 3.99371 2.63575 2.39623C4.3433 0.798742 6.42958 0 8.89461 0C11.3596 0 13.4579 0.797296 15.1894 2.39189C16.921 3.98645 17.7867 5.93492 17.7867 8.23728C17.7867 9.26149 17.5845 10.2704 17.1802 11.2642C16.7758 12.2579 16.2231 13.1069 15.5222 13.8113L25.7937 23.3585L25.1466 24ZM8.9306 15.6604C11.1705 15.6604 13.0582 14.9497 14.5938 13.5283C16.1293 12.1069 16.8971 10.3459 16.8971 8.24528C16.8971 6.14465 16.1293 4.38365 14.5938 2.96226C13.0582 1.54088 11.1705 0.830189 8.9306 0.830189C6.69074 0.830189 4.80302 1.54088 3.26744 2.96226C1.7319 4.38365 0.964121 6.14465 0.964121 8.24528C0.964121 10.3459 1.7319 12.1069 3.26744 13.5283C4.80302 14.9497 6.69074 15.6604 8.9306 15.6604Z"
              fill="#1C1C20"
            />
          </svg>
        </div>
        <input
          type="text"
          bind:value={searchTerm}
          placeholder="Search for Activity"
          disabled={!paginatedData || paginatedData.length === 0}
          on:input={handleInput}
        />
      </div>
    </div>
    <div class="new_activity">
      <Button
        text="New"
        icon="plus"
        on:click={() => {
          modalOpen = true;
          editActivityName = "";
          editActivityColor = "#93EDA3";
          editActivityId = "";
        }}
      />
    </div>
  </div>
  <Toggle text="Show all" bind:active={showall} />

  <div class="activities">
    {#if loading && activities.length > 0}
      {#each Array(5) as _, index}
        <div class="activity">
          <div class="color" style="background-color: #c9c9c9;"></div>
          <div class="activity_name" style="padding-top: 0.5rem;">
            <SkeletonText />
          </div>
        </div>
      {/each}
    {:else}
      {#each paginatedData as activity}
        <div class="activity">
          <div class="color" style="background-color: {activity.color};"></div>
          <div class="activity_name">
            <span>{activity.activity_name}</span>
          </div>
          <Button
            text="Edit"
            icon="edit"
            on:click={() => {
              modalOpen = true;
              editActivityName = activity.activity_name;
              editActivityColor = activity.color;
              editActivityId = activity.activityid ?? activity.id;
            }}
          />
        </div>
      {/each}
    {/if}
  </div>
  <div class="pagination_wrapper">
    <AssistantChevrons
      disabled={currentPage === 1}
      expand={true}
      on:buttonClicked={() => goToPage(currentPage - 1)}
    />
    <div class="pagination">
      <div class="bold">
        {(currentPage - 1) * itemsPerPage + 1} -
        {Math.min(currentPage * itemsPerPage, filteredData.length)}
      </div>
      of
      <div class="bold">{filteredData.length}</div>
    </div>
    <AssistantChevrons
      disabled={currentPage >= Math.ceil(filteredData.length / itemsPerPage)}
      expand={true}
      flip={true}
      on:buttonClicked={() => goToPage(currentPage + 1)}
    />
  </div>
</div>

<Modal
  size="lg"
  open={modalOpen}
  modalHeading={editActivityId ? "Edit Activity" : "Add Activity"}
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => {
    modalOpen = false;
  }}
  on:open={handleFocus}
  on:close={() => {
    modalOpen = false;
  }}
  on:submit={() => {
    saveActivity(
      editActivityName,
      editActivityColor,
      editActivityId,
      analysisid
    );
    updatePagination();
    modalOpen = false;
  }}
>
  <TextInput
    labelText="Name"
    placeholder="Enter name for Activity"
    bind:value={editActivityName}
    id={`text-input-${editActivityName}`}
  />
  <div class="color-selection">
    {#each listOfColors as color}
      <ButtonColorSelector
        color={color.value}
        setColor={() => setColor(color.value)}
      />
    {/each}
    <input type="color" bind:value={editActivityColor} class="color-input" />
  </div>
</Modal>

<style>
  /* pagination */

  .pagination_wrapper {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    align-items: center;
    background-color: white;
    width: 100%;
    padding-top: 1rem;
    border-top: 1px solid #c9c9c9;
  }

  .pagination {
    background-color: var(--pax-smoke);
    border-radius: 0.5rem;
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    gap: 0.5rem;
    padding: 0 1rem;
  }

  .activities {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .activity {
    display: flex;
    gap: 0.5rem;
    width: 100%;
    max-width: 100%;
  }

  .color {
    height: 3rem;
    aspect-ratio: 1/1;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
  }

  .activity_name {
    display: flex;
    height: 3rem;
    align-items: center;
    flex-grow: 1;
    flex-shrink: 1;
    background-color: var(--pax-smoke);
    padding: 0 1rem;
    border-radius: 0.5rem;
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .activity_name span {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input {
    border: none;
    padding-left: 1rem;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  input:focus,
  input:active {
    outline: none;
  }

  .top_bar {
    display: flex;
    gap: 0.5rem;
  }

  .search_wrapper {
    display: flex;
    gap: 0.5rem;
    flex-grow: 1;
    width: 100%;
    flex-shrink: 1;
    flex-grow: 1;
  }

  .search {
    border: 1px solid #1c1c20;
    border-radius: 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    height: 3rem;
    padding: 0 1rem;
  }

  .searchicon {
    height: 1.5rem;
  }

  .addToActivityWrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .color-selection {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .color-input {
    flex-grow: 1;
    flex-shrink: 1;
    box-sizing: border-box;
  }

  .search_wrapper.disabled,
  .search_wrapper.disabled .search {
    opacity: 0.5;
    cursor: not-allowed;
  }

  input:disabled {
    background-color: var(--pax-white);
    cursor: not-allowed;
  }
</style>
